import { CheckCircleOutline } from "@mui/icons-material";
import { Button, Link, Skeleton, Stack, Tooltip, Typography } from "@mui/material";
import { CreateTaskItemModal, TaskItemStatusPicker } from "src/components/taskItems";
import { isWhitespace, ItemProperty } from "..";
import { DEFAULT_TASK_ITEM_STATUS, Links, SupportingItemType } from "../../constants";
import { SupportingTaskItemDto } from "../../http";
import { useState } from "react";

interface IProps {
  items: SupportingTaskItemDto[];
  context?: {
    teamName: string;
    teamSlug: string;
    actionItemGuid: string;
    actionItemDescription: string;
  };
  parentTask?: {
    taskItemGuid: string;
    description: string;
  };
  isLoading?: boolean;
  onClick?: (type: SupportingItemType, taskItemGuid: string) => void;
}

const SupportingTaskItemsProperty = (props: IProps) => {
  const [isTaskItemModalVisible, setIsTaskItemModalVisible] = useState(false);

  function handleClicked(event: React.MouseEvent, taskItemGuid: string) {
    if (props.onClick) {
      event.preventDefault();
      props.onClick(SupportingItemType.TaskItem, taskItemGuid);
    }
  }

  return (
    <ItemProperty labelIcon={<CheckCircleOutline />} label="Tasks">
      <Stack spacing={0.5}>
        {props.isLoading ? (
          <Stack spacing={0.5}>
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} variant="rectangular" height={24} width={Math.random() * 175 + 75} />
            ))}
          </Stack>
        ) : (
          props.items.map((task) => (
            <Stack key={task.taskItemGuid} direction="row">
              <TaskItemStatusPicker
                taskItemGuid={task.taskItemGuid}
                status={task.currentStatus ?? DEFAULT_TASK_ITEM_STATUS}
                ownerUserGuids={[]}
                variant="button"
                disabled
              />
              <Tooltip
                title={
                  <Typography>
                    {task.team && (
                      <>
                        <strong>{task.team.name}</strong>
                        <span> : </span>
                      </>
                    )}
                    <Link href={Links.TaskItemDetail(task.taskItemGuid)}>{task.description}</Link>
                  </Typography>
                }
                placement="right"
              >
                <Link
                  href={Links.TaskItemDetail(task.taskItemGuid)}
                  onClick={(e) => handleClicked(e, task.taskItemGuid)}
                >
                  {task.description == null || isWhitespace(task.description) ? (
                    <Typography variant="placeholder">Nothing here yet.</Typography>
                  ) : (
                    <Typography>{task.description}</Typography>
                  )}
                </Link>
              </Tooltip>
            </Stack>
          ))
        )}

        <Button
          variant="tertiary"
          startIcon={<CheckCircleOutline />}
          sx={{ alignSelf: "start" }}
          onClick={() => setIsTaskItemModalVisible(true)}
        >
          Add
        </Button>
      </Stack>

      <CreateTaskItemModal
        visible={isTaskItemModalVisible}
        context={props.context}
        parentTask={props.parentTask}
        onCreated={() => setIsTaskItemModalVisible(false)}
        onCancelled={() => setIsTaskItemModalVisible(false)}
      />
    </ItemProperty>
  );
};

export { SupportingTaskItemsProperty };
